import { render, staticRenderFns } from "./ModalWithForm.vue?vue&type=template&id=6c5b410c&scoped=true&"
import script from "./ModalWithForm.vue?vue&type=script&lang=js&"
export * from "./ModalWithForm.vue?vue&type=script&lang=js&"
import style0 from "./ModalWithForm.vue?vue&type=style&index=0&id=6c5b410c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5b410c",
  null
  
)

export default component.exports